enum Sector {
  CROP = 'crop',
  LIVESTOCK = 'livestock',
}

export default Sector;
